import { StorageState } from '../../../reducers';
import { createDataFetchSliceSelectors } from '../../../utils/dataFetch';


export const adminAccountContragentsDictionarySliceSelector = (state: StorageState) => state.adminAccount.contragentsDictionary;

export const adminAccountContragentsDictionarySelectors = createDataFetchSliceSelectors(
    adminAccountContragentsDictionarySliceSelector
);
